/* eslint-disable prettier/prettier */
/* eslint-disable react/prop-types */
import EditViewModal from 'components/custom/modal/EditViewModal';
import InputBox from 'components/custom/forms/InputBox';
import LabelInput from 'components/custom/forms/LabelInput';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import useModalManage from 'hooks/custom/useModalManage';
import { Col, Form, Row } from 'react-bootstrap';
import apiEndpoints from 'constants/apiEndpoints';
import useHandleUpdate from '../../../hooks/custom/useHandleUpdate';
import DatePicker from 'components/base/DatePicker';
import classNames from 'classnames';
import { formatDate } from 'services/utils';

const EditShift = ({ show, handleClose, data, actions, handleRefresh }) => {
  const [modalLoading, modalMessage, setModalLoading] = useModalManage();
  const handleUpdate = useHandleUpdate(handleRefresh, handleClose);
  const formik = useFormik({
    initialValues: {
      shift_name: data.shift_name,
      start_time: data.start_time,
      end_time: data.end_time
    },
    validationSchema: Yup.object({
      shift_name: Yup.string()
        .required('Please provide the Shift name')
        .max(30, 'Shift Name cannot be longer than 30 characters')
    }),

    onSubmit: values => {

      handleUpdate(
        {
          ...values,
          start_time:
            values.start_time.split(':')?.length === 3
              ? values.start_time.split(':')?.slice(0, 2).join(':')
              : values.start_time,
          end_time:
            values.end_time.split(':')?.length === 3
              ? values.end_time.split(':')?.slice(0, 2).join(':')
              : values.end_time,
          shift_id: data.shift_id
        },
        apiEndpoints.shift.update(data.shift_id),
        setModalLoading,
        'Shift',
        data.shift_name
      );
    }
  });

  return (
    <EditViewModal
      loading={modalLoading}
      loadingText={modalMessage}
      show={show}
      handleClose={handleClose}
      status={'Active'}
      name={data.shift_name}
      data={data}
      actions={actions}
      handleSubmit={formik.handleSubmit}
      openEditMode={data.isEditable}
      isDisable={true}
    >
      {(inputRef, isEditable) => (
        <Row className="gy-2 gx-2">
          <Col xs={12} sm={12}>
            <InputBox>
              <LabelInput
                inputProps={{ ref: inputRef, readOnly: !isEditable }}
                label={'Shift Name'}
                controlId={'shift_name'}
                formik={formik}
              />
            </InputBox>
          </Col>
          <Col xs={12} sm={6}>
            <InputBox>
              <Form.Group
                className="position-relative"
                controlId={'start_time'}
              >
                <Form.Label
                  className={
                    'd-block mb-1 fs-9 ps-1 text-capitalize fw-medium fw-bold'
                  }
                >
                  Start Time*
                </Form.Label>

                <DatePicker
                  readOnly={!isEditable}
                  onChange={date => {
                    formik.setFieldValue(
                      'start_time',
                      formatDate(date[0], 'HH:mm')
                    );
                  }}
                  value={formik.values['start_time']}
                  options={{
                    dateFormat: 'h:i K',
                    enableTime: true,
                    noCalendar: true,
                    static: true
                  }}
                  className={classNames({
                    'is-invalid':
                      formik.touched['start_time'] &&
                      formik.errors['start_time']
                  })}
                  containerClassName={'custom-flat-picker'}
                >
                  <Form.Control.Feedback tooltip type="invalid">
                    {formik.errors['start_time']}
                  </Form.Control.Feedback>
                </DatePicker>
              </Form.Group>
            </InputBox>
          </Col>
          <Col xs={12} sm={6}>
            <InputBox>
              <Form.Group className="position-relative" controlId={'end_time'}>
                <Form.Label
                  className={
                    'd-block mb-1 fs-9 ps-1 text-capitalize fw-medium fw-bold'
                  }
                >
                  End Time*
                </Form.Label>

                <DatePicker
                  readOnly={!isEditable}
                  onChange={date =>
                    formik.setFieldValue(
                      'end_time',
                      formatDate(date[0], 'HH:mm')
                    )
                  }
                  value={formik.values['end_time']}
                  options={{
                    dateFormat: 'h:i K',
                    enableTime: true,
                    noCalendar: true,
                    static: true
                  }}
                  className={classNames({
                    'is-invalid':
                      formik.touched['end_time'] && formik.errors['end_time']
                  })}
                  containerClassName={'custom-flat-picker'}
                >
                  <Form.Control.Feedback tooltip type="invalid">
                    {formik.errors['end_time']}
                  </Form.Control.Feedback>
                </DatePicker>
              </Form.Group>
            </InputBox>
          </Col>
        </Row>
      )}
    </EditViewModal>
  );
};

export default EditShift;
